import { useTranslation } from 'react-i18next';

// Single cleaning record
const RecordCard = ({ record, onEdit, onDelete }) => {
    const { t } = useTranslation();
    return (<div className="bg-primary-800 border border-primary-50 rounded-2xl p-4">
        {/* Top row: ID + date */}
        <div className="flex justify-between items-center mb-2">
            <span className="text-primary-10 text-xs font-mono">={record.id}</span>
            <span className="text-white text-sm font-mono">{record.date}</span>
        </div>
        
        {/* Worker Name */}
        <p className="text-white font-medium mb-2">{record.name}</p>
        
        {/* House + Price */}
        <div className="flex justify-between items-center mb-4">
            <p className="text-primary-10 text-sm">{t('records.house')}: {record.house}</p>
            <p className="text-white text-lg font-semibold">${record.price}</p>
        </div>

        {/* Actions */}
        <div className="flex gap-2">
            <button
                onClick={(e) => onEdit(record)}
                className="flex-1 border border-secondary-800 text-secondary-800 bg-secondary-50 rounded-xl py-2 text-sm font-mono">
                EDIT
            </button>
            <button
                onClick={() => 
                    onDelete(record.id)}
                className="flex-1 border border-danger-800 text-danger-800 bg-danger-50 rounded-xl py-2 text-sm font-mono">
                DELETE
            </button>
        </div>
    </div>);
};

export default RecordCard;